import { groupBy } from "lodash"
import { getAnimationTimings } from "./constants"

// `game` only decides how fast the animations run (a quick game shortens them),
// so it stays optional — a caller without one gets the normal durations.
export const calculateAnimationDurations = (
  houseAnimations: IHouseAnimation[],
  game?: IGame
) => {
  const houseChangeDuration =
    calculateTotalDurationOfHouseChangeAnimation(houseAnimations, game) || 10

  const mortgageDuration = 3000
  return {
    houseChange: houseChangeDuration || 10,
    mortgage: 0,
    total: mortgageDuration + houseChangeDuration,
  }
}
export const calculateTotalDurationOfHouseChangeAnimation = (
  houseAnimations: IHouseAnimation[],
  game?: IGame
): number => {
  const groupedByPropertyOrders = groupBy(
    houseAnimations,
    (item) => item.propertyOrder
  )

  const durations = Object.entries(groupedByPropertyOrders).map(([k, v]) =>
    calculateTotalDurationFromGivenArray(v, game)
  )
  if (durations.length === 0) return 0
  return Math.max(...durations)
}

export const calculateTotalMortgageAnimationsDuration = (
  mortgageAnimations: IMortgageAnimations[],
  game?: IGame
) => {
  const timings = getAnimationTimings(game)
  const typeMortgage = mortgageAnimations.filter(
    (item) => item.type === "mortgated"
  )
  const typeUnMortgage = mortgageAnimations.filter(
    (item) => item.type === "un-mortgaged"
  )
  return {
    mortgage: typeMortgage.length ? timings.mortgage : 0,
    unMortgage: typeUnMortgage.length ? timings.unMortgage : 0,
  }
  return
}
const calculateTotalDurationFromGivenArray = (
  houseAnimations: IHouseAnimation[],
  game?: IGame
) => {
  const timings = getAnimationTimings(game)
  const addHouseAnimations = houseAnimations.filter(
    (anim) => anim.type === "add"
  )
  const removeHouseAnimations = houseAnimations.filter(
    (anim) => anim.type === "remove"
  )

  let addDuration =
    (addHouseAnimations.length - 1) * timings.houseAddDelay + timings.houseAdd

  let removeDuration =
    (removeHouseAnimations.length - 1) * timings.houseRemoveDelay +
    timings.houseRemove

  if (houseAnimations[0].index === 4) {
    if (houseAnimations[0].type === "add") {
      return timings.houseAdd
    }

    if (houseAnimations[0].type === "remove") {
      return timings.houseRemove
    }
  }
  const result =
    (addHouseAnimations.length ? addDuration : 0) +
    (removeHouseAnimations.length ? removeDuration : 0)
  if (result === null) return 0
  else return result
}
